
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [{"enable-background":"new 0 0 301.691 301.691"},style,staticStyle],
              attrs: Object.assign({"version":"1.1","id":"Capa_1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","viewBox":"0 0 301.691 301.691","style":"enable-background:new 0 0 301.691 301.691;","xml:space":"preserve"}, attrs),
              ...rest,
            },
            children.concat([_c('g',[_c('polygon',{attrs:{"points":"119.151,0 129.6,218.406 172.06,218.406 182.54,0 \t"}}),_c('rect',{attrs:{"x":"130.563","y":"261.168","width":"40.525","height":"40.523"}})]),_c('g'),_c('g'),_c('g'),_c('g'),_c('g'),_c('g'),_c('g'),_c('g'),_c('g'),_c('g'),_c('g'),_c('g'),_c('g'),_c('g'),_c('g')])
          )
        }
      }
    